<div class="component-container gas-connection-container">
  <app-review-section
    #gasConnectionSection
    [title]="gasConnectionHeaderTranslationKey | translate"
    [tooltip]="'tooltips.technician-form.gas-connection' | translate"
    [showTooltip]="infoBubblesData?.showGasSupplyInfo"
    [sectionId]="sectionIdentifier.TechnicalData_BaseData_Gas"
    [applicationId]="applicationId"
    [isDetailsView]="isDetailsView">
    <form [formGroup]="gasConnectionFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
      <div class="form-background">
        <div *ngIf="!this.showDisposalOfOilTankRadio" class="ui-g-12 form-rows">
          <div class="ui-g-6 field-rows">
            <label
              class="ui-g-5 field-label text-right-align"
              for="gas-connection-handover-location-power"
              [class.required]="isFieldRequired('handoverLocationPower')">
              {{
                (showConnectedLoadLabel
                  ? 'technician-data.form-fields.connected-load'
                  : 'technician-data.form-fields.handover-location-power'
                ) | translate
              }}
            </label>
            <input
              [appNumber]="true"
              class="ui-input pInputText small-width"
              formControlName="handoverLocationPower"
              id="gas-connection-handover-location-power"
              [readonly]="!gasConnectionSection.isDataEditable"
              pInputText
              size="30"
              maxlength="5" />
            <span class="field-unit-label">{{ unitLabels.power }}</span>
          </div>
          <div class="ui-g-6 field-rows padding-left-1" *ngIf="showInfoForCommodities">
            <span [innerHTML]="'technician-data.standard-gas-warning' | translate"></span>
          </div>
        </div>

        <div *ngIf="gasConnectionFG.get('disposalOfOilTank')" class="ui-g-12 form-rows">
          <div class="ui-g-6 field-rows">
            <label
              class="ui-g-5 field-label text-right-align"
              for="gas-connection-disposal-of-oil-tank"
              [class.required]="isFieldRequired('disposalOfOilTank')">
              {{ 'technician-data.form-fields.disposal-of-oil-tank' | translate }}
            </label>
            <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding radio-button-group">
              <p-radioButton
                formControlName="disposalOfOilTank"
                label="{{ 'yes-button-label' | translate }}"
                name="disposal-of-oil-tank"
                [value]="true"
                [disabled]="!gasConnectionSection.isDataEditable"></p-radioButton>
              <p-radioButton
                formControlName="disposalOfOilTank"
                label="{{ 'no-button-label' | translate }}"
                name="disposal-of-oil-tank"
                [value]="false"
                [disabled]="!gasConnectionSection.isDataEditable"></p-radioButton>
            </div>
          </div>
          <div class="ui-g-6 field-rows padding-left-1" *ngIf="showInfoForCommodities">
            <span [innerHTML]="'technician-data.standard-gas-warning' | translate"></span>
          </div>
        </div>

        <div *ngIf="gasConnectionFG.get('sizeOfTank')" class="ui-g-12 form-rows">
          <div class="ui-g-6 field-rows">
            <label
              class="ui-g-5 field-label text-right-align"
              for="gas-connection-size-of-tank"
              [class.required]="isFieldRequired('sizeOfTank')">
              {{ 'technician-data.form-fields.size-of-tank' | translate }}
            </label>
            <input
              [appNumber]="true"
              class="ui-input pInputText small-width"
              formControlName="sizeOfTank"
              id="gas-connection-size-of-tank"
              [readonly]="!gasConnectionSection.isDataEditable"
              pInputText
              size="30"
              maxlength="5" />
            <span class="field-unit-label">l³</span>
          </div>
        </div>

        <div *ngIf="gasConnectionFG.get('boilerOutputHeatingGas') && gasConnectionFG.get('waterTreatment')" class="ui-g-12 form-rows">
          <div class="ui-g-6 field-rows">
            <label
              class="ui-g-5 field-label text-right-align"
              for="gas-connection-boiler-output-heating-gas"
              [class.required]="isFieldRequired('boilerOutputHeatingGas')">
              {{ 'technician-data.form-fields.boiler-output-heating-gas' | translate }}
            </label>
            <input
              [appNumber]="true"
              class="ui-input pInputText small-width"
              formControlName="boilerOutputHeatingGas"
              id="gas-connection-boiler-output-heating-gas"
              [readonly]="!gasConnectionSection.isDataEditable"
              pInputText
              size="30"
              maxlength="5" />
            <span class="field-unit-label">{{ unitLabels.power }}</span>
          </div>
          <div class="ui-g-6 field-rows padding-left-1">
            <label
              class="ui-g-5 field-label text-right-align"
              for="gas-connection-water-treatment"
              [class.required]="isFieldRequired('waterTreatment')">
              {{ 'technician-data.form-fields.water-treatment' | translate }}
            </label>
            <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding radio-button-group">
              <p-radioButton
                formControlName="waterTreatment"
                label="{{ 'yes-button-label' | translate }}"
                name="water-treatment"
                [value]="true"></p-radioButton>
              <p-radioButton
                formControlName="waterTreatment"
                label="{{ 'no-button-label' | translate }}"
                name="water-treatment"
                [value]="false"></p-radioButton>
            </div>
          </div>
        </div>

        <div *ngIf="this.showDisposalOfOilTankRadio && gasConnectionFG.get('waterProtectionArea')" class="ui-g-12 form-rows">
          <div class="ui-g-6 field-rows">
            <label
              class="ui-g-5 field-label text-right-align"
              for="gas-connection-handover-location-power"
              [class.required]="isFieldRequired('handoverLocationPower')">
              {{
                (showConnectedLoadLabel
                  ? 'technician-data.form-fields.connected-load'
                  : 'technician-data.form-fields.handover-location-power'
                ) | translate
              }}
            </label>
            <input
              [appNumber]="true"
              class="ui-input pInputText small-width"
              formControlName="handoverLocationPower"
              id="gas-connection-handover-location-power"
              [readonly]="!gasConnectionSection.isDataEditable"
              pInputText
              size="30"
              maxlength="5" />
            <span class="field-unit-label">{{ unitLabels.power }}</span>
          </div>

          <div class="ui-g-6 field-rows padding-left-1">
            <label
              class="ui-g-5 field-label text-right-align"
              for="gas-connection-water-protection-area"
              [class.required]="isFieldRequired('waterProtectionArea')">
              {{ 'technician-data.form-fields.water-protection-area' | translate }}
            </label>
            <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding radio-button-group">
              <p-radioButton
                formControlName="waterProtectionArea"
                label="{{ 'yes-button-label' | translate }}"
                name="water-protection-area"
                [value]="true"></p-radioButton>
              <p-radioButton
                formControlName="waterProtectionArea"
                label="{{ 'no-button-label' | translate }}"
                name="water-protection-area"
                [value]="false"></p-radioButton>
            </div>
          </div>
        </div>

        <ng-container *ngIf="showUsageSection">
          <div class="usage-title">
            {{ 'technician-data.form-fields.usage-title' | translate }}
          </div>
          <div class="ui-g form-rows checkbox-row">
            <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
              <p-checkbox
                appEnterClick
                binary="true"
                [readonly]="!gasConnectionSection.isDataEditable"
                class="checkbox-field"
                id="heating-gas-checkbox"
                formControlName="heatingGasCheckbox"
                label="{{ 'technician-data.form-fields.heating-gas-checkbox' | translate }}"></p-checkbox>
            </div>

            <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding" *ngIf="currentFormType.index > 0">
              <p-checkbox
                appEnterClick
                binary="true"
                [readonly]="!gasConnectionSection.isDataEditable"
                class="checkbox-field"
                id="process-gas-checkbox"
                formControlName="processGasCheckbox"
                label="{{ 'technician-data.form-fields.process-gas-checkbox' | translate }}"></p-checkbox>
            </div>

            <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
              <p-checkbox
                appEnterClick
                binary="true"
                [readonly]="!gasConnectionSection.isDataEditable"
                class="checkbox-field"
                id="bhkw-checkbox"
                formControlName="bhkwCheckbox"
                label="{{ 'technician-data.form-fields.bhkw-checkbox' | translate }}"></p-checkbox>
            </div>

            <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
              <p-checkbox
                appEnterClick
                binary="true"
                [readonly]="!gasConnectionSection.isDataEditable"
                class="checkbox-field"
                id="cooking-gas-checkbox"
                formControlName="cookingGasCheckbox"
                label="{{ 'technician-data.form-fields.cooking-gas-checkbox' | translate }}"></p-checkbox>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </app-review-section>
</div>
